<template>
  <div class="tableTitle horizontal_layout">
    <div class="tableTitle-title" v-if="tableTitleData.title">{{ tableTitleData.title }}</div>
    <div class="tableTitle-sum flex" v-if="tableTitleData.totalType">共 {{ total }} {{ tableTitleData.totalType }}</div>
    <div class="tableTitle-sum flex" v-else>共 {{ total }} 条</div>
    <div class="table-but">
      <div v-for="(item, index) in tableTitleData.bntList" :key="index" v-show="!item.show">
        <el-button class="lm_spacing" v-if="item.function === 'import'" :icon="item.icon" @click="clickImport(item)">
          {{ item.name }}
          <input
            type="file"
            class="changeFiles"
            name
            id="special"
            value="文件上传"
            accept=".xlsx, .xls"
            @change="changeFile"
            style="cursor: pointer; position: absolute; width: 100%; height: 32px; left: 0; top: 0; opacity: 0"
          />
        </el-button>
        <el-button class="lm_spacing" v-else :class="{ addBtn: item.type === 'solid' }" :icon="item.icon" @click="clickBut(item)"
          >{{ item.name }}<span v-if="item.number">({{ item.number }})</span></el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tableTitleData', 'total'],
  data() {
    return {
      butTtem: ''
    };
  },
  methods: {
    clickBut(item) {
      this.$emit(item.click, item);
    },
    clickImport(item) {
      this.butTtem = item;
    },
    changeFile(e) {
      this.$emit(this.butTtem.click, e);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/index.scss';

.tableTitle {
  padding-bottom: $spacing;
  height: 30px;
  line-height: 30px;
  position: relative;
  &-title {
    font-size: $fontSize16;
    padding-right: 13px;
  }
  &-sum {
    font-size: $fontSize;
    color: $fontSize666;
  }
}
.table-but {
  display: flex;
  div {
    position: relative;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/module/tableTitle/index.vue